/**
 * @author gabyong.kim
 * @email gabyong.kim@gloovir.com
 * @create date 2023-11-17 15:49:03
 * @modify date 2023-11-17 15:49:03
 * @desc [description]
 */


import { CustomTextInput } from "components/base/CustomInputText";
import ContentBox from "components/base/tamplate/ContentBox";
import { Fragment, MouseEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import { View, Text, Pressable, StyleSheet, ScrollView } from "react-native";
import ListTable from "components/base/table/listTable";
import { BackupShareExternalData, BackupShareInternalData, externalTableHeader, internalTableHeader } from "./BackupShareData";
import { FONT } from "value/staticValues";
import { ContentContainerProps } from "interfaceTypes/ContentsProps";


import { ReactComponent as ImportArrowImg } from "../../../img/btn-pagination-left-active-arrow.svg";
import { ReactComponent as ExportArrowImg } from "../../../img/btn-pagination-right-active-arrow.svg";
import { CustomDropDown } from "components/base/CustomDropdown";
import { storageProtocolDropdownItem } from "./BackupData";
import CustomText from "components/base/CustomText";
import { CustomDeleteBtn } from "components/base/CustomDeleteBtn";



interface BackupShareViewProps extends ContentContainerProps {
  connectYn: boolean;
  internalBackupData: BackupShareInternalData[];
  externalBackupData: BackupShareExternalData[];
  connectCb: ()=>void;
  refreshCb: ()=>void;
  selectRowIntCb: (item)=>void;
  selectRowExtCb: (item)=>void;
  clickExportBtnCb: ()=>void;
  clickImportBtnCb: ()=>void;
  clickDeleteExternalCb: ()=>void;
  storageProtocol: string;
  setStorageProtocolCb: (v)=>void;
  storageIp: string;
  setStorageIpInputCb: (v)=>void;
  storagePort: string;
  setStoragePortCb: (v)=>void;
  storageAccount: string;
  setStorageAccountCb: (v)=>void;
  storagePassword: string;
  setStoragePasswordCb: (v)=>void;
  storagePath: string;
  setStoragePathCb: (v)=>void;
}



export default function BackupShareView(props: BackupShareViewProps) {
  const { t } = useTranslation();

  return (
    <ContentBox title={t("VM_BACKUP_SHARE_TITLE")} subtitle={t("VM_BACKUP_SHARE_DESC")} infoText={props.infoText} infoError={props.infoError} back={true}>
      <View style={style.topContainer}>
        <View style={{ ...style.boxContainer }}>
          <View style={{ flexDirection: "row", alignItems: "center", marginBottom: 50 }}>
            <Text style={style.boxContentTitle}>
              {t("BASE_INFO_TEXT")}
            </Text>
          </View>

          <View style={style.rowContainer}>
            <CustomText text={t("VM_BACKUP_RESOTRE_PROTOCOL")} fontStyle={style.boxContentHeaderText} asterisk={true}/>
            <CustomDropDown
              key={48}
              width={320} height={36}
              items={storageProtocolDropdownItem}
              value={props.storageProtocol}
              setValue={props.setStorageProtocolCb}
              disable={props.connectYn ? true : false}
              defaultvalue={{label:"SFTP", value:"SFTP"}}
            />
          </View>
          <View style={style.rowContainer}>
            <View style={{flexDirection: "row", alignItems: "center"}}>
              <CustomText text={t("VM_BACKUP_RESOTRE_IP")} fontStyle={style.boxContentHeaderText} asterisk={true}/>
              <CustomTextInput
                key={1}
                width={320} height={36}
                value={props.storageIp}
                type={"text"}
                activeYn={props.connectYn ? false : true}
                inputCb={props.setStorageIpInputCb}
                warnYn={false}
                placeHolderText={t("IP_ADDRESS_ENTER_MESSAGE")} />
              <View style={{width: 80}} />
              <CustomText text={t("VM_BACKUP_RESOTRE_PORT")} fontStyle={style.boxContentHeaderText} asterisk={true}/>
              <CustomTextInput
                key={2}
                width={320} height={36}
                value={props.storagePort}
                type={"text"}
                activeYn={props.connectYn ? false : true}
                inputCb={props.setStoragePortCb}
                warnYn={false}
                placeHolderText={t("PROTOCOL_PORT_ENTER_MESSAGE")} />
              </View>
          </View>

          <View style={style.rowContainer}>
            <View style={{flexDirection: "row", alignItems: "center"}}>
              <CustomText text={t("VM_BACKUP_RESOTRE_ACCOUNT")} fontStyle={style.boxContentHeaderText} asterisk={true}/>
              <CustomTextInput
                key={3}
                width={320} height={36}
                value={props.storageAccount}
                type={"text"}
                activeYn={props.connectYn ? false : true}
                inputCb={props.setStorageAccountCb}
                warnYn={false}
                placeHolderText={t("PROTOCOL_ACCOUNT_ENTER_MESSAGE")} />
              <View style={{width: 80}} />
              <CustomText text={t("VM_BACKUP_RESOTRE_PASSWORD")} fontStyle={style.boxContentHeaderText} asterisk={true}/>
              <CustomTextInput
                key={4}
                width={320} height={36}
                value={props.storagePassword}
                type={"password"}
                activeYn={props.connectYn ? false : true}
                inputCb={props.setStoragePasswordCb}
                warnYn={false}
                placeHolderText={""} />
              </View>
          </View>

          <View style={style.rowContainer}>
            <CustomText text={t("VM_BACKUP_RESOTRE_PATH")} fontStyle={style.boxContentHeaderText} asterisk={true}/>
            <CustomTextInput
              key={5}
              width={935} height={36}
              value={props.storagePath}
              type={"text"}
              activeYn={props.connectYn ? false : true}
              inputCb={props.setStoragePathCb}
              warnYn={false}
              placeHolderText={t("MOUNT_PATH_ENTER_MESSAGE")} />
          </View>
          <Text style={{...style.boxDescription, marginLeft: 200, marginTop: -10}}>
            {t("VM_BACKUP_LOAD_DESCRIPTION_MESSAGE")}
          </Text>

          <View style={{ width: '100%', flexDirection: "row", justifyContent: 'center', alignItems: 'center' }}>
            <Pressable style={style.buttonConfirmContainer}
              onPress={() => { props.connectCb() }}
            >
              <Text style={style.buttonConfirmTextStyle}>
                {(props.connectYn ? t("DISCONNECT_TEXT") : t("CONNECT_TEXT"))}
              </Text>
            </Pressable>
            {
              props.connectYn === true
              ? <Fragment>
              <View style={{width: 30}}/>
              <Pressable style={style.buttonConfirmContainer}
                onPress={() => { props.refreshCb() }}
              >
                <Text style={style.buttonConfirmTextStyle}>
                  {t("RELOAD_TEXT")}
                </Text>
              </Pressable>
            </Fragment>
            : null
            }
          </View>
        </View>

        <View style={{...style.boxContainer}}>
          <View style={{flexDirection: "row", alignItems: 'center'}}>
              <View style={{flex: 1, alignItems: 'center'}}>
                <Text style={{...style.boxContentTitle, fontFamily: FONT.BOLD, color: "#3a3b3f"}}>
                  {t("VM_BACKUP_INTERNAL_STORAGE")}
                </Text>
              </View>

              <View style={{flex: 1, alignItems: 'center'}}>
                <Text style={{...style.boxContentTitle, fontFamily: FONT.BOLD, color: "#3a3b3f", flex: 1, alignSelf: 'center'}}>
                {t("VM_BACKUP_EXTERNAL_STORAGE")}
                </Text>
              </View>
          </View>


          <View style={{flexDirection: 'row'}}>
            <View style={{flex: 1, marginRight: 10}}>
              <Pressable style={{width: 110, height: 30, marginLeft: "auto", flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'flex-end', paddingRight: 20}}
                onPress={()=>{props.clickExportBtnCb()}}
              >
                <Text style={{fontFamily: FONT.REGULAR, fontSize: 14, color: "#0853fb", marginRight: 10}}>{t("VM_BACKUP_RESOTRE_EXPORT")}</Text>
                <ExportArrowImg/>
              </Pressable>

              <ScrollView style={{height: 720, marginTop: 20}}>
                <ListTable
                  id={"internalStorage"}
                  searchBarYn={false}
                  pageYn={false}
                  rowCheckYn={true}
                  fetchDataCb={()=>null}
                  pageCount={1}
                  pageSize={9999}
                  rowCheckCb={props.selectRowIntCb}
                  tableHeaders={internalTableHeader}
                  tableData={props.internalBackupData || []}
                  totalItemCount={11}
                  detailYn={false}
                  refreshYn={false}
                  canLoadYn={false}/>
                </ScrollView>
            </View>


            <View style={{flex: 1, marginLeft: 10}}>
              <View style={{flexDirection: "row", alignItems: "flex-start"}}>
                <Pressable style={{width: 110, height: 30, marginRight: "auto", flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-end', paddingLeft: 10}}
                  onPress={()=>{props.clickImportBtnCb()}}
                >
                  <ImportArrowImg/>
                  <Text style={{fontFamily: FONT.REGULAR, fontSize: 14, color: "#0853fb", marginLeft: 10}}>{t("VM_BACKUP_RESOTRE_IMPORT")}</Text>
                </Pressable>
                <CustomDeleteBtn
                  text={t("DELETE_TEXT")} size={{width: 50, height: 24}} onPress={(e)=>{props.clickDeleteExternalCb()}} />
              </View>

              <ScrollView style={{height: 720, marginTop: 20}}>
                <ListTable
                  id={"externalStorage"}
                  searchBarYn={false}
                  pageYn={false}
                  rowCheckYn={true}
                  fetchDataCb={()=>null}
                  pageCount={1}
                  pageSize={9999}
                  tableHeaders={externalTableHeader}
                  rowCheckCb={props.selectRowExtCb}
                  tableData={props.externalBackupData || []}
                  totalItemCount={1}
                  detailYn={true}
                  refreshYn={false}
                  canLoadYn={false} />
              </ScrollView>

            </View>
          </View>
        </View>
      </View>

    </ContentBox>
  );
}




const style = StyleSheet.create({
  topContainer: {
      width: 1415,
      minHeight: 860,
  },
  boxContainer: {
      marginTop: 20,
      paddingTop: 34, paddingLeft: 50, paddingRight: 40, paddingBottom: 45,
      borderRadius: 8,
      boxShadow: "0 10px 12px 0 rgba(63, 63, 68, 0.05), 0 1px 3px 0 rgba(0, 0, 0, 0.05)",
      borderStyle: "solid", borderWidth: 1, borderColor: "#e5e9ec",
      backgroundColor: "#fff"
  },
  dateTitle: {
      marginRight: 10,
      fontFamily: FONT.REGULAR,
      fontSize: 10,
      color: "#8793a3"
  },
  dateData: {
      fontFamily: FONT.REGULAR,
      fontSize: 12,
      color: "#9ea0a5"
  },
  boxContentTitle: {
      fontFamily: FONT.MEDIUM,
      fontSize: 14,
      color: "#333"
  },
  boxDescription: {
    fontFamily: FONT.REGULAR,
    fontSize: 12,
    color: "#8c9299"
},
  boxContentHeaderText: {
      width: 200,
      fontFamily: FONT.REGULAR,
      fontSize: 13,
      lineHeight: 12,
      color: "#333"
  },
  boxContentDataText: {
      fontFamily: FONT.REGULAR,
      fontSize: 12,
      color: "#333"
  },
  boxContentBlueDataText: {
      fontFamily: FONT.REGULAR,
      fontSize: 12,
      color: "#0853fb"
  },
  rowContainer: {
    height: 36,
    flexDirection: "row",
    marginBottom: 30,
    alignItems: "center"
  },
  buttonConfirmContainer: {
    width: 70,
    height: 36,
    borderRadius: 10,
    borderStyle: "solid",
    backgroundColor: '#4f5fd8',
    justifyContent: "center",
    alignItems: "center",
    marginLeft: 10
  },
  buttonConfirmTextStyle: {
    fontSize: 12,
    lineHeight: 10,
    color: '#ffffff',
    fontFamily: FONT.MEDIUM,
  }
});